<button mat-icon-button class="dialog-close-btn" (click)="onNoClick()">
  <mat-icon>close</mat-icon>
</button>
@if (companyName()) {
  <h1 mat-dialog-title>ETF Tear Sheet - {{ companyName() }}</h1>
}
<div mat-dialog-content>
  <app-line-chart
    [series]="closeAdjData()"
    [extraOptions]="extraOptions()"
  ></app-line-chart>
  <div>
    <h3 class="summary-header cursor-pointer">Description</h3>
    <div class="overflow-hidden">
      <p class="overview-text mt-3">{{ overview()["descr"] }}</p>

      <div class="row">
        <div class="col-md-6">
          <div class="info-section">
            @for (info of sectionsA; track info.id) {
              <div class="info-line">
                <span class="info-title">{{ info.title }}</span>
                <span class="info-value">
                  @if (!info.type) {
                    <span
                      >{{ overview()[info.id] || "-" }}
                      @if (info.unit) {
                        <small class="text-muted">{{ info.unit }}</small>
                      }
                    </span>
                  }
                  @if (info.type === "money") {
                    <span>
                      {{ overview()[info.id] | number: "1.0-0" }}
                      @if (info.unit) {
                        <small class="text-muted">{{ info.unit }}</small>
                      }
                    </span>
                  }
                </span>
              </div>
            }
          </div>
        </div>
        <div class="col-md-6">
          <div class="info-section">
            @for (info of sectionsB; track info.id) {
              <div class="info-line">
                <span class="info-title">{{ info.title }}</span>
                <span class="info-value">
                  <span
                    >{{ overview()[info.id] || "-" }}
                    @if (info.unit) {
                      <small class="text-muted">{{ info.unit }}</small>
                    }
                  </span>
                </span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-4">
    <button
      mat-flat-button
      class="float-end"
      color="primary"
      (click)="onNoClick()"
    >
      Close
    </button>
  </div>
</div>
